<template>
  <div class="grid grid-rows-[auto_1fr] h-full overflow-hidden">
    <ThreadsNav show-back>
      <template #center>
        <h2>{{ t(isEdit ? "collection.edit" : "collection.create") }}</h2>
      </template>
      <template #right>
        <button class="btn btn-primary btn-sm" @click="clickCreate">
          {{ t(isEdit ? "Buttons.save" : "Buttons.create") }}
        </button>
      </template>
    </ThreadsNav>
    <div class="p-4 overflow-auto">
      <!-- 标题 -->
      <div>
        <div class="flex items-center justify-between mb-2">
          <h2 class="text-base font-bold">
            {{ $t("collection.title") }}
            <span class="text-[#E84B4B]">*</span>
          </h2>
        </div>
        <VanField
          v-model="form.title"
          :placeholder="$t('collection.titleDesc')"
          class="bg-base-100 border rounded"
          required
        />
      </div>

      <!-- 简介 -->
      <div>
        <div class="flex items-center justify-between mt-3 mb-2">
          <h2 class="text-base font-bold">
            {{ $t("collection.summer") }}
            <span class="text-[#E84B4B]">*</span>
          </h2>
        </div>

        <VanField
          v-model="form.description"
          :autosize="{ minHeight: 100 }"
          :placeholder="$t('collection.summerDesc')"
          class="bg-base-100 border rounded"
          rows="1"
          type="textarea"
        />
      </div>

      <!-- 邀请共创者 -->
      <div>
        <div class="flex items-center justify-between mt-3 mb-2">
          <h2 class="text-base font-bold">
            {{ $t("collection.inviteCreator") }}
          </h2>
          <!-- <div class="text-primary cursor-pointer">
            {{ t(`collection.know`) }}
          </div> -->
        </div>

        <div v-if="form.participantzz?.length" class="border w-full">
          <ul class="flex gap-2.5 p-2.5 flex-shrink-0 overflow-auto">
            <li
              v-for="(item, idx) in form.participantzz"
              :key="item.id"
              class="min-w-[68px] max-w-[68px] flex flex-col justify-center items-center"
            >
              <BaseImg class="rounded-sm" :url="item.mediaUrl" ratio="3:4" />
              <p class="line-clamp-1 text-center mt-1">
                {{ item.name }}
              </p>
              <div>
                <button
                  :class="[
                    'btn btn-xs  mt-1',
                    item.id === mateStore.currentMate?.id && 'opacity-0',
                  ]"
                  :disabled="item.id === mateStore.currentMate?.id"
                  @click="clickDelParticipant(idx)"
                >
                  <i class="iconfont icon-delete text-xs"></i>
                </button>
              </div>
            </li>
          </ul>
        </div>

        <div class="text-center mt-2.5">
          <button class="btn btn-sm rounded" @click="clickAddCreator">
            +
            {{ $t("collection.addCreator") }}
          </button>
        </div>
      </div>

      <!-- 合集封面 -->
      <div>
        <div class="flex items-center justify-between mt-3 mb-2">
          <h2 class="text-base font-bold">
            {{ $t("collection.cover") }}
            <!-- <span class="text-[#E84B4B]">*</span> -->
          </h2>
        </div>

        <div class="flex flex-col items-center mt-2.5">
          <UserAvatar
            v-if="form.coverMedia"
            :avatar-url="form.coverMedia?.url"
            aspect="1/1"
            class="object-cover w-[200px] mb-2"
            high-quality
          />

          <button class="btn btn-sm rounded" @click="showImgUploadModal = true">
            <template v-if="form.coverMedia">
              <i class="iconify mingcute--edit-3-line mt-[-1px]"></i>
              {{ $t("Buttons.replace") }}
            </template>
            <template v-else>
              +
              {{ $t("Buttons.add") }}
            </template>
          </button>
        </div>
      </div>

      <!-- 是否公开 -->
      <!-- 类型 -->
      <div class="flex items-center justify-between mt-3 mb-2">
        <h2 class="text-base font-bold">
          {{ $t("collection.isPublic") }}
          <span class="text-[#E84B4B]">*</span>
        </h2>
      </div>

      <VisibilitySelect v-model:visibility="form.visibility" />
    </div>

    <media-select-popup
      v-model:show="showImgUploadModal"
      :crop-aspect-ratio="1 / 1"
      :max-count="1"
      :multiple="false"
      :upload-type="7"
      enable-crop
      media-type="img"
      replace
      @on-media-selected="onMediaSelected"
    />
    <!-- <ModalCollectionSelectMate
    v-model:show="showAddCreatorModal"
    @mate-select="onSelectCreator"
  /> -->
  </div>
</template>

<script lang="ts" setup>
import { MediaUploadFileItem } from "@/types/component";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import {
  PickerConfirmEventParams,
  showConfirmDialog,
  showFailToast,
  showLoadingToast,
  showSuccessToast,
} from "vant";
import { onMounted } from "vue";
import { useMate } from "@/stores/mate";
import { useRoute, useRouter } from "vue-router";
import { Mate, Media } from "@/types/entity";
import { useUI } from "@/stores/ui";
import { Collection } from "@/types/collection";
import { StorageSet } from "@/tools/localStorage";
import { useCollection } from "@/stores/collection";
import VisibilitySelect from "@/components/mobile/common/VisibilitySelect.vue";

const { t } = useI18n();

const mateStore = useMate();
const collectionStore = useCollection();
const showImgUploadModal = ref(false);
const route = useRoute();
const router = useRouter();
const { uuid } = route.query;
const isEdit = ref(!!uuid);

const form = ref<Collection>({
  title: "",
  description: "",
  coverMediaId: 0,
  visibility: 2,
  participantzz: [],
});

const onMediaSelected = (mediaList: MediaUploadFileItem[]) => {
  const { mediaId, url } = mediaList[0];
  form.value.coverMediaId = mediaId;
  form.value.coverMedia = { url } as Media;
};

const onSelectCreator = (mate: Mate) => {
  form.value.participantzz?.push(mate);
};

const showSelectType = ref(false);
const onConfirmSelectGameType = (value: PickerConfirmEventParams) => {
  const visibility = value.selectedOptions[0]!.value! as 1 | 2 | 3;
  form.value.visibility = visibility;
  showSelectType.value = false;
};

const clickCreate = async () => {
  const { title, description, coverMediaId, visibility, participantzz } =
    form.value;

  if (!title) return showFailToast(t("Message.titleRequired"));
  if (!description) return showFailToast(t("Message.descriptionRequired"));

  const loading = showLoadingToast({
    message: t("Message.creating"),
  });
  const params: Partial<Collection> = {
    mateId: mateStore.currentMate?.id,
    title,
    description,
    coverMediaId,
    visibility,
    //@ts-ignore
    participantzz: participantzz!.map((item: Mate) => ({
      mateId: item.id,
    })),
  };

  try {
    if (isEdit.value) {
      await collectionStore.updateCollection(String(uuid), params);
      StorageSet("collectionUpdated", 1);
    } else {
      await collectionStore.createCollection(params);
    }
    showSuccessToast({
      message: t("Message.createdSuccessfully"),
      onClose: () => {
        router.back();
      },
    });
    loading.close();
  } catch (e) {
    loading.close();
  }
};

const clickDelParticipant = async (idx: number) => {
  try {
    await showConfirmDialog({
      title: t("collection.deleteParticipant"),
      message: t("collection.deleteParticipantDesc"),
      confirmButtonText: t("Buttons.confirm"),
      cancelButtonText: t("Buttons.cancel"),
      confirmButtonColor: "#E84B4B",
    });
    form.value.participantzz?.splice(idx, 1);
  } catch (e) {
    console.log(e);
  }
};

const uiStore = useUI();
const clickAddCreator = () => {
  uiStore.popMateSelector({
    mateOnly: true,
    exclude: form.value.participantzz!.map((v) => v.id),
    switchMate: false,
    callback: (mate: Mate) => {
      form.value.participantzz?.push(mate);
      uiStore.showMateSelector = false;
    },
  });
};

onMounted(async () => {
  const { uuid } = route.query;
  if (uuid) {
    const loading = showLoadingToast({
      message: t("Message.loading"),
    });
    const item = await collectionStore.getCollection(String(uuid));

    item.participantzz = item.participantzz!.filter((v: Mate) => !v.isUser);
    form.value = item;

    loading.close();
  } else {
    form.value.participantzz = [];
  }
});
</script>
